// Which expense-claim actions the signed-in user can take. Mirrors the
// backend rules in BE-ESS ess/expense/views.py (ExpenseClaimGenericView):
// - the approver whose turn it is approves or rejects;
// - the expense approver configured today can decide anyone else's pending
//   claim at any level (their decision is final);
// - nobody decides their own claim, except the expense approver once it has
//   reached their own step (after the line manager, or straight away when
//   they have no line manager);
// - the employee withdraws their own pending claim.

const PENDING = "pending";

export const isExpenseApprover = (user) =>
  [true, "True", "true"].includes(user?.is_expense_approver);

// Ids can arrive as numbers or strings; compare them as strings.
const sameId = (a, b) => a != null && b != null && String(a) === String(b);

const roles = (user, claim) => {
  const isOwner = sameId(user?.id, claim?.company_user?.id);
  const isCurrent = sameId(user?.id, claim?.current_approver?.id);
  const approver = isExpenseApprover(user);
  return {
    isOwner,
    canDecide: isOwner ? isCurrent && approver : isCurrent || approver,
  };
};

/** Status values the user may submit for this claim, e.g. ["approved", "rejected"]. */
export const getExpenseActions = (user, claim) => {
  if (!user || !claim || claim.approval_status !== PENDING) return [];
  const { isOwner, canDecide } = roles(user, claim);
  const actions = canDecide ? ["approved", "rejected"] : [];
  if (isOwner) actions.push("cancelled");
  return actions;
};

/**
 * The employee edits their own claim in the form; everyone else, and an
 * employee who is also deciding it, gets the review view.
 */
export const opensEditor = (user, claim) => {
  if (!user || !claim) return false;
  const { isOwner, canDecide } = roles(user, claim);
  return isOwner && !canDecide;
};

/** "Waiting for <name>" while pending; null once the claim is closed. */
export const waitingOnText = (claim) => {
  if (claim?.approval_status !== PENDING) return null;
  const approver = claim?.current_approver;
  if (!approver) return "Waiting for an approver";
  return `Waiting for ${[approver.first_name, approver.last_name].filter(Boolean).join(" ")}`;
};
